// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","inputs":"App_inputs__vpOxD","phone":"App_phone__Kq2Is","whatsapp":"App_whatsapp__51GBE","footer":"App_footer__aawhi"};